var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonsDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C5.89543 9 5 9.89543 5 11C5 12.1046 5.89543 13 7 13C8.10457 13 9 12.1046 9 11C9 9.89543 8.10457 9 7 9Z",
    stroke: "#50618B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.6227C1 12.314 1.63214 13.9361 2.75736 15.1321C3.88258 16.3281 5.4087 17 7 17C8.5913 17 10.1174 16.3281 11.2426 15.1321C12.3679 13.9361 13 12.314 13 10.6227C13 7.09975 10.3145 1 6.99783 1C3.68118 1 1 7.09975 1 10.6227Z",
    stroke: "#50618B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonsDevicesIcon);
export default __webpack_public_path__ + "static/media/Buttons_Devices_Icon.04b28e95f3d360dc0436b1c49d7f035d.svg";
export { ForwardRef as ReactComponent };